import React, { useEffect, useState } from "react";
import useStyles from "../../../../../components/common/model/styles";
import Popup from "../../../../../components/common/model/Popup";
import checkedIcon from "../../../../../assets/check-mark.png";
import deleteIcon from "../../../../../assets/trash.png";
import closeIcon from "../../../../../assets/closeModel.png";
import {
  addStaffAbsenceAction,
  getSingleStaffAbsenceAction,
  initialAbsenceState,
  initialAssignWorkerState,
} from "../../../../../store/reducers/assignWorkerSlice";
import { useDispatch } from "react-redux";
import Validation from "../../../../../utils/Validation";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../../components/common/notification/Notification";
import FormField from "../../../../../components/common/FormField";
import { setNotificationAction } from "../../../../../store/reducers/mmymSlice";
import { STAFF_ABSENCE_FORM_FIELDS } from "../staffAllFields";
import { useSelector } from "react-redux";
import { getAllSubUserAction } from "../../../../../store/reducers/subUserSlice";
import dayjs from "dayjs";
import ResetFormAlert from "../../../../../components/common/ResetFormAlert";

interface ManageAbsenceProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedStaff: any; // Adjust type as per your requirement
  action?: any;
  setSelectedStaff?: any;
  selectedAbsenceId?: any;
}

const ManageAbsence: React.FC<ManageAbsenceProps> = ({
  open,
  onHide,
  title,
  selectedStaff,
  action,
  setSelectedStaff,
  selectedAbsenceId,
}) => {
  const classes = useStyles();
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [staffDetails, setStaffDetails] = useState<any>(initialAbsenceState);

  const [isClickReset, setIsClickReset] = useState(false);

  const [alerModeShow, setAlertModelShow] = useState(false);
  const { userProfile } = useSelector((state: any) => state.user);
  const { users } = useSelector((state: any) => state.subUser);
  const { singleStaffAbsence } = useSelector(
    (state: any) => state.assignWorker
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedAbsenceId && action === "edit") {
      dispatch(getSingleStaffAbsenceAction(selectedAbsenceId));
    }
  }, [selectedAbsenceId]);

  useEffect(() => {
    if (open) {
      dispatch(getAllSubUserAction({ status: "" }));
      // 👇 set default authorised_by when modal opens
      setStaffDetails((prev: any) => ({
        ...prev,
        authorised_by: userProfile?.name || "", // or currentUser?.id
      }));
    }
  }, [open]);
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    reason: staffDetails?.reason,
    start_date: staffDetails?.start_date,
  });

  const handleInputChange = (field: string, value: any) => {
    setStaffDetails((prevState: any) => {
      if (field === "skills") {
        // Always trust the multi-select array
        return { ...prevState, skills: [...value] };
      }
      return { ...prevState, [field]: value };
    });

    resetValidator(field);
  };

  const onBlurAction = (event: any) => {
    checkValidator(event.target.id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
    console.log("called api");
  };

  const hideHandler = () => {
    onHide();
    // setSelectedStaff(null);
    resetAllValidator();
    setStaffDetails(initialAssignWorkerState);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  // Extract vehicle types from the vehicleTypes array
  const userListData = users.map((item: any) => ({
    id: item?.name,
    label: item?.name,
  }));

  const updatedFields = STAFF_ABSENCE_FORM_FIELDS.map((field) => {
    if (field.id === "authorised_by") {
      return { ...field, options: userListData, type: "select" };
    }
    return field;
  });

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        if (
          action === "edit" &&
          selectedStaff &&
          Object.keys(selectedStaff).length > 0
        ) {
          dispatch(
            addStaffAbsenceAction({
              worker_id: selectedStaff,
              ...staffDetails,
            })
          );
        } else {
          // remove id from payload
          const { id, ...rest } = staffDetails;
          dispatch(
            addStaffAbsenceAction({
              ...rest,
              worker_id: selectedStaff,
            })
          );
        }
        setIsActionCalled(false);
      } else {
        console.log("error in form", error);
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleClear = () => {
    if (singleStaffAbsence?.id && action === "edit") {
      setStaffDetails({ ...singleStaffAbsence });
    } else {
      setStaffDetails(initialAbsenceState);
    }
    // setSelectedStaff(null);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();
    setIsClickReset(false);
  };

  useEffect(() => {
    if (singleStaffAbsence?.id && action === "edit") {
      setStaffDetails({ ...singleStaffAbsence });
    }
  }, [singleStaffAbsence]);

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"md"}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              // style={{ right: 40 }}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText
            sx={{
              background: "#E5F4F1",
              padding: "10px 10px 10px 0px",
              border: "1px solid #CFCFCF",
              borderRadius: "5px",
            }}
          >
            <>
              <Notification />
              <Grid container spacing={1}>
                {updatedFields?.map((field, i) => {
                  let dynamicField = { ...field };
                  return (
                    <>
                      <FormField
                        key={field.id}
                        onPaste={(e: any) =>
                          field?.id === "name" || field?.id === "email"
                            ? ""
                            : e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (
                            [8, 9, 37, 38, 39, 40, 18, 17].includes(
                              event.keyCode
                            ) ||
                            event.ctrlKey
                          )
                            return event;
                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          } else if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(
                              event.target.value + event.key
                            )
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...dynamicField,
                          value: staffDetails
                            ? staffDetails[dynamicField.id]
                            : dynamicField.type === "multiSelectChip"
                            ? [] // default array for multi-select
                            : "",
                          inSingleGridForm: true,
                          minDate:
                            field.id === "end_date"
                              ? staffDetails?.start_date &&
                                dayjs(staffDetails.start_date).toDate()
                              : undefined,
                          maxDate:
                            field.id === "start_date"
                              ? staffDetails?.end_date &&
                                dayjs(staffDetails.end_date).toDate()
                              : undefined,
                          variant: "outlined",
                          // ✅ Pass the current country code to FormField

                          onChange: (value: any) => {
                            if (
                              Array.isArray(value) &&
                              field.type === "multiSelectChip"
                            ) {
                              // For FormMultiChipCheckbox (multiSelectChip)
                              handleInputChange(field.id, value);
                            } else {
                              // For normal inputs (event)
                              handleInputChange(
                                field.id,
                                value?.target?.value ?? value
                              );
                            }
                          },
                          onBlur: onBlurAction,
                          isNonMarginTop: true,
                          GridFieldStyle: {
                            paddingLeft:
                              field.type === "daterangebothvalue" ||
                              field.type === "date"
                                ? "8px !important"
                                : "auto",
                          },
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx:
                              field.type === "text" || field.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                          error: error && error[field.id],
                        }}
                      />
                    </>
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageAbsence;
